<template>
    
    <div class="">
        <div id="northeast-scroll-wrapper">
            
            <div class="map-figure map-scroll-wrapper__map" id="northeast-scroll-wrapper-item">
                <img class="map-figure__bg" :src="`${getURL()}/${require('@/assets/img/Map/newnortheast-map.jpg')}`" />

                <figure class="map-figure__layer">
                    <svg class="map-figure__svg" width="1920" height="700" viewBox="0 0 1920 700" fill="none"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g class="event">






                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '115',
                            )}`"
                                d="M621.096 267.783L699.982 153.226C700.396 152.624 701.105 152.296 701.832 152.37L809.423 163.357C810.867 163.505 811.678 165.092 810.951 166.349L733.68 299.914C733.224 300.701 732.296 301.082 731.419 300.841L622.213 270.845C620.886 270.481 620.315 268.916 621.096 267.783Z"
                                fill="#2BB673" fill-opacity="0.25" stroke="#2BB673" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '502',
                            )}`"
                                d="M513.851 367.564L579.173 299.857C579.683 299.329 580.44 299.122 581.147 299.318L805.067 361.409C806.669 361.854 807.061 363.946 805.728 364.94L723.279 426.419C722.787 426.786 722.154 426.907 721.562 426.747L514.768 370.883C513.299 370.486 512.794 368.659 513.851 367.564Z"
                                fill="#2BB673" fill-opacity="0.25" stroke="#2BB673" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '504',
                            )}`"
                                d="M416.681 468.101L498.692 377.889C499.189 377.342 499.948 377.114 500.664 377.296L716.913 432.216C718.342 432.579 718.9 434.311 717.952 435.44L637.329 531.513C636.824 532.114 636.015 532.364 635.259 532.153L417.623 471.372C416.19 470.972 415.68 469.202 416.681 468.101Z"
                                fill="#2BB673" fill-opacity="0.25" stroke="#2BB673" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '111',
                            )}`"
                                d="M494.427 231.904L570.23 140.057C570.647 139.552 571.286 139.283 571.94 139.337L692.109 149.404C693.63 149.532 694.453 151.246 693.603 152.513L615.326 269.032C614.839 269.757 613.938 270.082 613.1 269.834L495.403 235.095C494.027 234.689 493.514 233.01 494.427 231.904Z"
                                fill="#2BB673" fill-opacity="0.25" stroke="#2BB673" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '104',
                            )}`"
                                d="M1009.98 424.228L985.906 526.773C985.674 527.758 984.743 528.415 983.737 528.303L763.278 503.698C762.266 503.585 761.5 502.73 761.5 501.711V488.68C761.5 488.239 761.641 487.816 761.912 487.468C764.633 483.977 780.45 463.939 798.5 446.5C815.284 430.284 844.473 409.967 848.924 406.896C849.31 406.63 849.755 406.525 850.222 406.569L1008.22 421.781C1009.43 421.897 1010.25 423.049 1009.98 424.228Z"
                                fill="#D82D2D" fill-opacity="0.25" stroke="#D82D2D" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '105',
                            )}`"
                                d="M1217 437.375V542.354C1217 543.514 1216.02 544.431 1214.86 544.349L992.346 528.665C991.116 528.579 990.257 527.411 990.54 526.211L1014.61 424.145C1014.84 423.195 1015.71 422.546 1016.69 422.609L1215.13 435.38C1216.18 435.447 1217 436.321 1217 437.375Z"
                                fill="#D82D2D" fill-opacity="0.25" stroke="#D82D2D" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '106',
                            )}`"
                                d="M1436.26 448.591L1454.1 557.041C1454.3 558.303 1453.29 559.433 1452.01 559.362L1221.89 546.605C1220.83 546.546 1220 545.669 1220 544.608V438.104C1220 436.96 1220.96 436.049 1222.1 436.107L1434.39 446.918C1435.33 446.966 1436.11 447.662 1436.26 448.591Z"
                                fill="#D82D2D" fill-opacity="0.25" stroke="#D82D2D" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '109',
                            )}`"
                                d="M1322.64 336.207L1330.81 435.199C1330.91 436.413 1329.91 437.434 1328.7 437.36L1159.04 427.122C1157.92 427.055 1157.07 426.081 1157.17 424.964L1164.36 336.203C1164.44 335.222 1165.2 334.446 1166.19 334.375C1174.35 333.78 1210.36 331.246 1234.5 330.999C1265.29 330.685 1311.49 333.739 1320.82 334.382C1321.8 334.45 1322.56 335.224 1322.64 336.207Z"
                                fill="#D82D2D" fill-opacity="0.25" stroke="#D82D2D" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '110',
                            )}`"
                                d="M1159.85 336.139L1153.64 425.469C1153.56 426.585 1152.59 427.42 1151.47 427.323L863.326 402.159C862.293 402.069 861.489 401.198 861.903 400.247C867.613 387.141 932.749 362.197 979.5 352.5C1045.78 338.753 1118.81 334.165 1157.88 334.004C1159.04 334 1159.93 334.982 1159.85 336.139Z"
                                fill="#D82D2D" fill-opacity="0.25" stroke="#D82D2D" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '116',
                            )}`"
                                d="M738.806 300.741L816.981 166.365C817.376 165.686 818.132 165.301 818.913 165.381L926.75 176.404C928.105 176.542 928.928 177.965 928.372 179.209L858.916 334.681C858.513 335.583 857.512 336.056 856.559 335.794L740.003 303.675C738.738 303.327 738.146 301.875 738.806 300.741Z"
                                fill="#2BB673" fill-opacity="0.25" stroke="#2BB673" />
                            <path :id="`id_${landPlotStore.HOUSE_TO_PLOT_NUMBER_MAP.get(
                                '119',
                            )}`"
                                d="M864.267 333.377L934.92 178.544C935.274 177.769 936.079 177.304 936.927 177.383L1054.61 188.464C1055.67 188.563 1056.47 189.474 1056.42 190.537L1051.88 301.337C1051.84 302.333 1051.09 303.145 1050.1 303.245C1040.22 304.242 989.539 309.479 955.328 315.502C925.401 320.772 880.308 332.519 866.597 336.155C864.96 336.59 863.564 334.918 864.267 333.377Z"
                                fill="#2BB673" fill-opacity="0.25" stroke="#2BB673" />









                        </g>
                    </svg>
                </figure>

                <img class="map-figure__layer map-figure__layer--disabled"
                    :src="`${getURL()}/${require('@/assets/img/Map/newnortheast-map-numbers.png')}`" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { landPlotStore } from '@/store/modules/LandPLot';
import { MixinDetailSection } from '@/mixins/MixinDetailSection';
import { getURL } from '@/helpers/routeHelpers';
MixinDetailSection();



</script>
<style lang=""></style>
